import { message, notification } from "antd";
import { convertServiceTierFormToApiValues } from "../Helpers/ServiceTierHelpers";
import { APIResponseStatus, ServiceTierActions } from "../Constants/Constants";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service Tier ${
      action === ServiceTierActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceTierActions.add ? "adding" : "updating"
  } Service Tier`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, record, serviceTierApi, deviceModelRecord } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info === "ERROR-NAME-ALREADY-PRESENT") {
            notification["error"]({
              message: `Error creating Service Tier`,
              description: `Service Tier name already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === ServiceTierActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.serviceTierId = record?.serviceTierId;
      const formattedData = convertServiceTierFormToApiValues(values, action);
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceTierActions.add) {
        serviceTierApi.addServiceTier(formattedData, formSubmitCallback);
      } else {
        serviceTierApi.updateServiceTier(formattedData, formSubmitCallback);
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
